export default __webpack_public_path__ + "audio/trum.1ca50b69.mp3";